
import React, { useState, useEffect } from "react";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Verifica se o usuário já deu consentimento
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookieConsent", "all");
    setShowBanner(false);
  };

  const handleAcceptEssential = () => {
    localStorage.setItem("cookieConsent", "essential");
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div
      className="cookie-consent-banner"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#2c3e50",
        color: "white",
        padding: "20px",
        zIndex: 10000,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8">
            <h5 className="mb-2">
              <i className="bi bi-info-circle me-2"></i>
              Uso de Cookies
            </h5>
            <p className="mb-2 small">
              Utilizamos cookies essenciais para o funcionamento do site e cookies opcionais 
              para melhorar sua experiência. Você pode escolher quais aceitar.
            </p>
            <p className="mb-0 small">
              <strong>Cookies essenciais:</strong> Autenticação, sessão de usuário<br/>
              <strong>Cookies opcionais:</strong> Preferências, análise de uso
            </p>
          </div>
          <div className="col-md-4 text-md-end">
            <div className="d-flex flex-column gap-2">
              <button
                className="btn btn-success btn-sm"
                onClick={handleAcceptAll}
              >
                <i className="bi bi-check-all me-1"></i>
                Aceitar Todos
              </button>
              <button
                className="btn btn-warning btn-sm"
                onClick={handleAcceptEssential}
              >
                <i className="bi bi-check me-1"></i>
                Apenas Essenciais
              </button>
              <button
                className="btn btn-outline-light btn-sm"
                onClick={handleRejectAll}
              >
                <i className="bi bi-x me-1"></i>
                Rejeitar Todos
              </button>
            </div>
          </div>
        </div>
        
        <div className="mt-3 text-center">
          <small className="text-light">
            Ao continuar navegando, você concorda com nossa{" "}
            <a href="/politica-privacidade" className="text-warning">
              Política de Privacidade
            </a>{" "}
            e{" "}
            <a href="/termos-de-uso" className="text-warning">
              Termos de Uso
            </a>
          </small>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
